import React, { useEffect, useState, useRef } from "react";
import "./styles.css";
import ReactPlayer from "react-player";
import { Camera } from "react-camera-pro";
import { hatchback, videoSteps } from "./data";
//
import baseUrlNew from "../BaseUrl/index"

import axios from "axios";
import { useHistory } from "react-router-dom";
import {
  setsingleimage,
  } from "../Redux/reduxflow/action"
import RotateDeviceScreen from "../components/RotateDeviceScreen";
import CameraAccessScreen from "../components/CameraAccessScreen";
import DeskTopView from "../Desktopview";
import Camra from "../Camra"
import video from '../assets/hatchback-v3-motorway-400kbs-HQ.mov';
import video_android from '../assets/hatchback-v3-1104x828-30fps.webm'
import { connect } from "react-redux";
import {
  BrowserView,
  MobileView,
} from "react-device-detect";
import {
  getViewportScreenMode,
  subscribeViewportOrientation,
} from "../utils/viewportOrientation";
import { isSecureCameraContext } from "../utils/isMobilePhotoDevice";
import {
  landscapeShutterToolbarStyle,
  landscapeShutterButtonStyle,
} from "../utils/landscapeShutterStyle";
import { enterImmersiveMode, exitImmersiveMode } from "../utils/immersiveMode";
import FullscreenCapturePrompt from "../components/FullscreenCapturePrompt";
import CameraZoomControls from "../components/CameraZoomControls";
import UploadErrorScreen from "../components/UploadErrorScreen";
import GuidedCompleteScreen from "../components/GuidedCompleteScreen";
import {
  getCameraVideoElement,
  takeZoomedPhoto,
} from "../utils/cameraZoom";
import {
  getUploadErrorMessage,
  isEvaluationImagesError,
  isInsufficientCreditMessage,
} from "../utils/uploadError";
function CameraOverlay({ id, close, setsingleimage_a, resumeIndex = 0 })  {


  const history = useHistory();
  // console.log("platform-------------> ",window.navigator.platform)

  const camera = React.useRef(null);
  const [imgSrc, setImgSrc] = React.useState([]);
  const [playVideo, setplayVideo] = React.useState(false);
  const [seekAmount, setseekAmount] = React.useState(1);
  const [isMobile, setisMobile] = useState(false);
  const [guidedComplete, setGuidedComplete] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [timeout, settimeout] = useState(0);
  const [video_index, setVindex] = useState(1);
  const [orientation, setorientation] = useState("portrait");
  const videoPlayer = useRef(null);
  const video_index_ref = React.useRef(0);
  const [stepUi, setStepUi] = useState(0);
  const [imgename, setimgename] = useState("");
  const [carimge, setcarimge] = useState("");
  const [temp_number, setnumber] = useState(0);
  const [sec, setsecs] = useState([0]);
  var index=1;
  const scrollInto = useRef(null)
  const captureRootRef = useRef(null)
  const [cameraZoom, setCameraZoom] = useState(1);
  // console.log("car imge state",carimge)
  // console.log("car imge name  state",imgename)

  const [sreen, setsreen] = useState(getViewportScreenMode);
  const [cameraSessionKey, setCameraSessionKey] = useState(0);
  const [cameraReady, setCameraReady] = useState(false);
  const [cameraTimedOut, setCameraTimedOut] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const canUseCamera = isSecureCameraContext();
  const isIOSDevice = window.navigator.platform === "iPhone";
  const guideVideoUrl = isIOSDevice ? video : video_android;
  const arr = [].concat.apply([], Object.values(videoSteps));

  const syncStep = (nextIndex) => {
    const safe = Math.max(0, Math.min(Number(nextIndex) || 0, Math.max(arr.length - 1, 0)));
    video_index_ref.current = safe;
    setStepUi(safe);
    setVindex(safe + 1);
  };

  const seekGuideToStep = (stepIndex) => {
    const step = arr[stepIndex];
    if (!step || !videoPlayer.current?.seekTo) return;
    const seconds = Number(step.start_at);
    videoPlayer.current.seekTo(
      Number.isFinite(seconds) ? Math.max(0, seconds) : 0,
      "seconds"
    );
  };

  useEffect(() => {
    if (!arr.length) return;
    const start = Math.max(0, Math.min(Number(resumeIndex) || 0, arr.length - 1));
    syncStep(start);
    setplayVideo(false);
    // Seek after player mounts; also handled in onReady.
    const timer = window.setTimeout(() => seekGuideToStep(start), 400);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resumeIndex, arr.length]);

  useEffect(() => {
    return subscribeViewportOrientation(setsreen);
  }, []);

  useEffect(() => {
    if (sreen !== "landscap") {
      exitImmersiveMode();
      return undefined;
    }

    enterImmersiveMode(captureRootRef.current || document.documentElement);

    return () => {
      exitImmersiveMode();
    };
  }, [sreen]);

  const requestImmersive = () => {
    enterImmersiveMode(captureRootRef.current || document.documentElement);
  };

  useEffect(() => {
    if (sreen !== "landscap" || !canUseCamera) {
      setCameraReady(false);
      setCameraTimedOut(false);
      return undefined;
    }

    setCameraReady(false);
    setCameraTimedOut(false);

    const timeoutId = window.setTimeout(() => {
      setCameraTimedOut(true);
    }, 8000);

    return () => window.clearTimeout(timeoutId);
  }, [sreen, canUseCamera, cameraSessionKey]);

  const retryCamera = () => {
    setCameraSessionKey((value) => value + 1);
  };
  // reqId = requestAnimationFrame(async function  play()  {
  //   var cur_time=await videoPlayer.current.getCurrentTime()
  //   console.log("current time--->> ",cur_time, ' --- vindex ',index)
  //   if(cur_time>=arr[index].start_at && cur_time<=arr[index].stop_at){
  //     setplayVideo(false)
  //     // console.log("Video seconds--->> ",videoPlayer.current.getCurrentTime()," --- ",arr[video_index].sec);
  //   }
    
  //   reqId = requestAnimationFrame(play);
  // });

  const requestRef = React.useRef();
  const previousTimeRef = React.useRef(false);

  useEffect(() => {
    previousTimeRef.current = playVideo;
  }, [playVideo]);
  
  const animate = () => {
    if (previousTimeRef.current && videoPlayer.current?.getCurrentTime) {
      const getCurrentTime = videoPlayer.current.getCurrentTime();
      const step = arr[video_index_ref.current];
      if (
        step &&
        getCurrentTime >= step.start_at &&
        getCurrentTime <= step.stop_at
      ) {
        setplayVideo(false);
        previousTimeRef.current = false;
      }
    }

    requestRef.current = requestAnimationFrame(animate);
  };
  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, []);
  useEffect(() => {
    // scrollInto.current.scrollIntoView()
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };







  // =========================api call section ==============
  const baseUrl =
  `${baseUrlNew.baseUrl}api/v1/evaluation_images/`;

  const advanceAfterUpload = () => {
    if (video_index_ref.current + 1 === arr.length) {
      exitImmersiveMode();
      setGuidedComplete(true);
      return;
    }
    syncStep(video_index_ref.current + 1);
    setplayVideo(true);
  };

  const handleUploadFailure = (errorOrResponse) => {
    exitImmersiveMode();
    setUploadError(getUploadErrorMessage(errorOrResponse));
  };

  const PostCarimge = (image, data) => {
    setUploading(true);
    setUploadError("");
    axios
      .post(baseUrl, {
        name: data.title,
        type: data.type,
        image_data: image,
        evaluate_image: id,
      })
      .then((response) => {
        if (isEvaluationImagesError(response)) {
          handleUploadFailure(response);
          return;
        }
        setsingleimage_a(response.data);
        advanceAfterUpload();
      })
      .catch((error) => {
        handleUploadFailure(error);
      })
      .finally(() => {
        setUploading(false);
      });
  };

  // check
  // const initialCheck = () => {
  //   const angle = window.orientation;
  //   setisMobile(navigator.userAgentData.mobile);
  //   if (angle === 90) {
  //     setorientation("landscape");
  //   } else {
  //     setorientation("portrait");
  //   }
  // };
  // useEffect(initialCheck, []);
  // window.addEventListener("orientationchange", initialCheck);
  //
  // console.log("device orientation", orientation);
  // console.log("device props", props);
  // console.log("device isMobileprops", isMobile);
  // console.log("device orientation", orientation);
  // console.log("device navigator.userAgent", navigator);
  // console.log("device navigator.userAgent", navigator.userAgent);
  // console.log("device navigator.userAgentData", navigator.userAgentData.mobile);
  // console.log("device window.matchMedia", window.matchMedia);
  // const capture = React.useCallback(() => {
  //   const imageSrc = camera .current.getScreenshot();
  //   setImgSrc([...imgSrc, imageSrc]);
  //   console.log("imgSrc", imgSrc);
  //   // setImgSrc(imageSrc);
  // }, [camera , setImgSrc]);
  // const setplayVideoHandler = (sec = 0) => {
  //   // console.log("captureHandler setplayVideoHandler sec", sec);
    
  //   const timeoutID =window.setTimeout(() => {
  //     window.clearTimeout(timeout );
  //     setplayVideo(false);
  //   }, sec * 1000);
  //   setplayVideo(true);
  //   settimeout(timeoutID)
  // };
  //
  //
  const captureHandler = () => {
    requestImmersive();

    if (!camera.current?.takePhoto || !arr[video_index_ref.current]) {
      return;
    }

    const imageSrc = takeZoomedPhoto(
      camera,
      getCameraVideoElement(captureRootRef.current),
      cameraZoom
    );
    if (!imageSrc || uploading) {
      return;
    }

    // Only advance after evaluation_images succeeds
    PostCarimge(imageSrc, arr[video_index_ref.current]);
  };
  
  const videoPlayerHandler = (e) => {
    //   const [temp_number, setnumber] = useState(0)
    // const [sec,setsecs]=useState([0])
    // const cur = temp_number;
    // console.log("Temp Number ", temp_number);

    // const videoPlayer_ = videoPlayer.current;
    // setplayVideo(true);
    // setplayVideo(!playVideo);
    const getCurrentTime = videoPlayer.current.getCurrentTime();
    console.log("current time-->> ",getCurrentTime)
    if(getCurrentTime>=arr[index].start_at && getCurrentTime<=arr[index].stop_at){
      setplayVideo(false)
      // console.log("Video seconds--->> ",videoPlayer.current.getCurrentTime()," --- ",arr[video_index].sec);
    }
    // setsecs([...sec, getCurrentTime - cur]);
    // setnumber(getCurrentTime);

    // console.log(sec);
    // console.log("videoPlayerHandler getCurrentTime", getCurrentTime);
  };
  return guidedComplete ? (
    <GuidedCompleteScreen
      photoCount={arr.length}
      onExit={() => {
        if (typeof close === "function") {
          close(true);
        }
      }}
    />
  ) : uploadError ? (
    <UploadErrorScreen
      message={uploadError}
      onRetry={
        isInsufficientCreditMessage(uploadError)
          ? undefined
          : () => setUploadError("")
      }
    />
  ) : (
    <>
      <BrowserView>
        <DeskTopView />
      </BrowserView>
      <MobileView>
        {!canUseCamera ? (
          <CameraAccessScreen reason="insecure" />
        ) : sreen !== "landscap" ? (
          <RotateDeviceScreen description="Hold your phone horizontally to capture vehicle photos." />
        ) : cameraTimedOut && !cameraReady ? (
          <CameraAccessScreen reason="permission" onRetry={retryCamera} />
                ) : (
          <div
            ref={captureRootRef}
            className="container_ pi-pictures-camera pi-pictures-camera--landscape"
            onTouchStart={requestImmersive}
            onClick={requestImmersive}
          >
            <FullscreenCapturePrompt targetRef={captureRootRef} />
            <div className="camera_main_cont">
              <div className="camera_wrapper">
                <Camera
                  key={cameraSessionKey}
                  facingMode="environment"
                  aspectRatio="cover"
                  width="100%"
                  height="100%"
                  ref={camera}
                  videoReadyCallback={() => {
                    setCameraReady(true);
                    setCameraTimedOut(false);
                  }}
                  errorMessages={{
                    noCameraAccessible:
                      "No camera found. Try another browser or check device settings.",
                    permissionDenied:
                      "Camera permission denied. Allow access in browser settings and try again.",
                  }}
                />
                <div className="video_wrapper" aria-hidden="true">
                  <ReactPlayer
                    ref={videoPlayer}
                    playing={playVideo}
                    muted
                    width="90%"
                    height="90%"
                    playsinline
                    url={guideVideoUrl}
                    onReady={() => seekGuideToStep(video_index_ref.current)}
                  />
                </div>
                <div ref={scrollInto} className="bottom_title_bar flex_center pi-capture-step">
                  <span className="pi-capture-step__pulse" aria-hidden />
                  <div className="pi-capture-step__text">{`${stepUi + 1} / ${arr.length} ${
                    arr[stepUi]?.title || "Photo"
                  }`}</div>
                </div>
                {!cameraReady ? (
                  <div className="pi-camera-loading" aria-live="polite">
                    Starting camera…
                  </div>
                ) : null}
                {cameraReady ? (
                  <CameraZoomControls
                    rootRef={captureRootRef}
                    zoom={cameraZoom}
                    onZoomChange={setCameraZoom}
                  />
                ) : null}
              </div>
              <div
                className="tool_bar pi-capture-toolbar"
                style={landscapeShutterToolbarStyle}
              >
                {!playVideo && cameraReady && !uploading ? (
                  <button
                    type="button"
                    className="round_button flex_center pi-capture-shutter"
                    onClick={captureHandler}
                    aria-label="Capture photo"
                    style={landscapeShutterButtonStyle}
                  >
                    <div className="round_button_ flex_center" />
                  </button>
                ) : null}
                {uploading ? (
                  <div className="pi-camera-loading" aria-live="polite">
                    Uploading photo…
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </MobileView>
    </>
  );
};
const mapStateToProps = (state) => ({
  userId: state.cardata.data,
});
const mapDispatchToProps = dispatch => {
    return {
      setsingleimage_a: (response) => dispatch(setsingleimage(response)),
  
    }
  }
export default connect(mapStateToProps, mapDispatchToProps)(CameraOverlay);
